import React from 'react'
import Game from './Game'
import { render, getConfig, TYPE_QUESTIONS, shuffle, initErrorMonitoring } from '@educaplay/core'
import { assetsUrl, GameProvider } from '@educaplay/core'
import { initialize } from '@educaplay/store'
import { getQuestionsWithScreens } from './utils/questions'
import { isUnansweredAnswer } from '@educaplay/store/utils/functions'
import { GAME_MODES } from './utils/constants'

initErrorMonitoring("https://3167a5160156e6d0d25327470865780d@o4509038211104768.ingest.de.sentry.io/4509441007091792", {
  tracesSampleRate: 0.05
});

const gameImage = assetsUrl("MAPA/logoActivity.png");
const container = document.getElementById('root');


const MAPA_SOUNDS = {
  "goodActive": assetsUrl('MAPA/bienactivo.mp3'),
  "charge": assetsUrl('MAPA/carga.mp3'),
  "write": assetsUrl('MAPA/escribir.mp3'),
  "move": assetsUrl('MAPA/mover.mp3'),
  "correct": assetsUrl('MAPA/correcto.mp3'),
  "activate": assetsUrl('MAPA/activar.mp3'),
  "place": assetsUrl('MAPA/colocar.mp3'),
}


async function init() {
  const { data, texts, settings, user, title, description, author, id, url } = await getConfig().catch((err) =>
    console.error('Error al obtener la configuración: ', err)
  )

  const { resources } = settings;
  const questions = getQuestionsWithScreens({ data, resources });


  const restartGameHandler = () => {
    if (data.ALEATORIO !== "si") return questions;

    const questionsByScreen = questions.reduce((acc, q) => ((acc[q.screenId] ||= []).push(q), acc), {});
    const questionsShuffle = Object.keys(questionsByScreen)
      .sort((a, b) => a - b)
      .flatMap(key => shuffle(questionsByScreen[key]));
    return questionsShuffle;
  };


  initialize({
    lives: data.NUMERO_INTENTOS,
    countFooterSpace: true,
    liveActived: data.NUMERO_INTENTOS_INFINITOS !== "si",
    hasCountDown: data.MAXIMO === "si",
    globalCountdown: data.TIEMPO,
    randomized: false,
    showSolutions: data.OCULTAR_RESPUESTAS !== "1",
    showButtonReports: data.OCULTAR_RESPUESTAS !== "1",
    showRestart: data.OCULTAR_REINICIAR !== "1",
    showSocialMedia: data.OCULTAR_REDES !== "1",
    finalText: data.TEXTO_FINAL,
    allowAnswerRepetition: true,
    hasProgressBar: { view: true, onlyCorrect: true },
    hasBank: true,
    hasInfinityTries: true,
    automaticallyFinishGame: false,
    refreshQuestions: restartGameHandler,
    questions,
    settings,
    title,
    description,
    author,
    id,
    url,
    user,
    customizations: {
      customLogo: data.LOGO,
      customBarLogo: data.FRANJA,
      backgroundImage: { src: data.BACKGROUND, showGame: false },
      colors: {
        primary: data.COLOR_FONDO,
        text: data.COLOR_FUENTE,
        action: data.COLOR_BOTONES,
        textAction: data.COLOR_FUENTE_B,
      }
    }
  });

  render(container, (

    <GameProvider
      gameImage={gameImage}
      texts={texts}
      Game={Game}
      sounds={MAPA_SOUNDS}
      onRestartGame={restartGameHandler}
      hasCustomLayout

      mappers={{
        report: (question) => {
          if (question.mode === GAME_MODES.EXPLORE) return;

          const isCorrect = question.checkAnswer(question.answer)
          const questionID = question.originId;

          const formatAnswer = (answer) => {
            if (answer.type === TYPE_QUESTIONS.Selection) return answer.answer.split('-')[1];
            if (answer.type === TYPE_QUESTIONS.Text) return answer.answer;
          }

          const triesArray = question.tries.map(entry => {
            return {
              s: false,
              i: questionID,
              a: formatAnswer(entry)
            }
          });

          const answer = {
            s: isCorrect,
            i: questionID,
            a: formatAnswer(question.answer)
          }

          return [...triesArray, answer];
        }
      }}

      renders={{
        infoRight: (currentIndex, questions) => {
          const screenPoints = questions.filter(question => question.screenId === questions[currentIndex].screenId);
          const answeredQuestions = screenPoints.filter(question => !isUnansweredAnswer(question.answer) && question.checkAnswer(question.answer));
          return `${texts.specific.point}: ${answeredQuestions.length} / ${screenPoints.length}`
        }
      }}
    />

  ))
}

init();